import PropTypes from 'prop-types'
import {
  Table, Select,
  Button, Input,
  DatePicker, Tag,
} from 'antd'
import Helper from 'utils/Helper'

const AutoDebitPendaftaranView = ({
  isFetching, dataAutoDebitPendaftaran, metaAutoDebitPendaftaran,
  statusList, isExport, handleSearch,
  handleChangeStatus, handleChangeDate, handlePage,
  handleReport,
}) => {
  const columns = [
    {
      title: 'No',
      dataIndex: '',
      key: 'No',
      width: 90,
      render: (text, record, index) => (metaAutoDebitPendaftaran.per_page * (metaAutoDebitPendaftaran.current_page - 1)) + index + 1,
    },
    {
      title: 'Nama',
      dataIndex: 'name',
      key: 'name',
      width: 150,
      render: text => text || '-',
    },
    {
      title: 'Member ID',
      dataIndex: 'registered_number',
      key: 'registered_number',
      width: 110,
      render: text => text || '-',
    },
    {
      title: 'Nomor Rek',
      dataIndex: 'account_number',
      key: 'account_number',
      width: 130,
      render: text => text || '-',
    },
    {
      title: 'No. Telepon',
      dataIndex: 'phone_number',
      key: 'phone_number',
      width: 150,
      render: text => text || '-',
    },
    {
      title: 'Iuran',
      dataIndex: 'deposit_frequency',
      key: 'deposit_frequency',
      width: 100,
      render: text => text || '-',
    },
    {
      title: 'Amount',
      dataIndex: 'debit_amount',
      key: 'debit_amount',
      width: 130,
      render: text => Helper.convertPrice(text) || '-',
    },
    {
      title: 'Tanggal Pendebetan',
      dataIndex: 'debit_date',
      key: 'debit_date',
      width: 205,
      render: text => text || '-',
    },
    {
      title: 'Tanggal',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 110,
      render: text => text || '-',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 110,
      render: (text) => {
        let tags
        if (text === 'active') {
          tags = <Tag color="green" className="text-capitalize">{text || '-'}</Tag>
        } else if (text === 'in progress') {
          tags = <Tag color="yellow" className="text-capitalize" style={{ borderColor: '#fadb14', fontWeight: '500' }}>{text || '-'}</Tag>
        } else if (text === 'failed') {
          tags = <Tag color="red" className="text-capitalize">{text || '-'}</Tag>
        } else {
          tags = <Tag className="bg-transparent text-capitalize" style={{ borderColor: '#8f8f8f', color: '#8f8f8f', fontWeight: '500' }}>{text || '-'}</Tag>
        }
        return tags
      },
    },
  ]

  return (
    <div>
      <div className="pb-3 d-flex justify-content-between">
        <div className="d-flex justify-content-start">
          <div className="mr-3 btn-primary-wrapper">
            <Input.Search
              allowClear
              placeholder="Search...."
              onSearch={handleSearch}
              enterButton
            />
          </div>
          <div className="mr-3">
            <Select
              placeholder="Status"
              style={{ width: 120 }}
              onChange={handleChangeStatus}
              allowClear
            >
              {statusList.map(item => <Select.Option key={item.id} value={item.value}>{item.label}</Select.Option>)}
            </Select>
          </div>
          <div className="mr-3">
            <DatePicker.RangePicker
              format="YYYY-MM-DD"
              placeholder={['Start Date', 'End Date']}
              onChange={handleChangeDate}
            />
          </div>
        </div>
        <div className="btn-primary-wrapper">
          <Button
            loading={isExport}
            type="primary"
            className="align-items-center"
            onClick={handleReport}
          >
            Export
          </Button>
        </div>
      </div>
      <Table
        rowKey="id"
        className="table-striped-rows"
        loading={isFetching}
        columns={columns}
        scroll={{ x: 1000 }}
        dataSource={dataAutoDebitPendaftaran}
        pagination={{
          showTotal: (total, range) => `Showing ${range[0]} to ${range[1]} of ${total} entries`,
          pageSize: metaAutoDebitPendaftaran ? metaAutoDebitPendaftaran.per_page : 10,
          total: metaAutoDebitPendaftaran ? metaAutoDebitPendaftaran.total_count : dataAutoDebitPendaftaran.length,
          current: metaAutoDebitPendaftaran ? metaAutoDebitPendaftaran.current_page : 1,
          onChange: handlePage,
        }}
      />
    </div>
  )
}

AutoDebitPendaftaranView.propTypes = {
  isFetching: PropTypes.bool,
  dataAutoDebitPendaftaran: PropTypes.array,
  metaAutoDebitPendaftaran: PropTypes.object,
  statusList: PropTypes.array,
  isExport: PropTypes.bool,
  handleSearch: PropTypes.func,
  handleChangeStatus: PropTypes.func,
  handleChangeDate: PropTypes.func,
  handlePage: PropTypes.func,
  handleReport: PropTypes.func,
}

export default AutoDebitPendaftaranView
